import { useNavigate } from 'react-router-dom';
import { useInboxFavorites } from './use-inbox-favorites';


export const usePrimaryInbox = () => {
    const navigate = useNavigate();
    const { data: favorites, isFetched } = useInboxFavorites();

    const primaryInboxId = favorites?.find(fav => fav.is_primary)?.inbox_id ?? 'default';

    return {
        goToPrimaryInbox() {
            if (isFetched) {
                navigate(`/landlord/inner/inboxes/${primaryInboxId}`);
            }
        },
        goToDefaultInbox() {
            navigate('/landlord/inner/inboxes/default');
        },
        primaryInboxId,
        isReady: isFetched,
    };
};
